import React from 'react';
import { Link } from 'react-router-dom';
import { BsLinkedin, BsGithub, BsInstagram, BsYoutube } from 'react-icons/bs';

const Footer = () => {
  return (
    <>
      {/* Newsletter Section */}
<footer className="py-4 bg-dark text-white w-100">
  <div className="px-2">
    <div className="row justify-content-left g-3">
      <div className="col-12 col-md-10">
        <div className="d-flex flex-column flex-md-row align-items-center gap-3 text-center text-md-start">
          <img
            src="images/newsletter.png"
            alt="newsletter"
            className="img-fluid"
            style={{ maxWidth: '120px' }}
          />
          <h2 className="mb-0 fs-4">
            Where blessings meet choices – shop with heart, receive with grace.
          </h2>
        </div>
      </div>
    </div>
  </div>
</footer>


      {/* Contact & Links Section */}
      <footer className="py-4 bg-dark text-white">
        <div className="container-xxl">
          <div className="row row-cols-2 row-cols-md-4 g-4">
            {/* Contact Us */}
            <div>
              <h5>Contact Us</h5>
              <address>Address</address>
              <p className="mb-1">+91 8925220366</p>
              <p className="mb-2">demo@gmail.com</p>
              <div className="d-flex gap-3">
                <a className="text-white" href="#"><BsLinkedin className="fs-5" /></a>
                <a className="text-white" href="#"><BsGithub className="fs-5" /></a>
                <a className="text-white" href="#"><BsInstagram className="fs-5" /></a>
                <a className="text-white" href="#"><BsYoutube className="fs-5" /></a>
              </div>
            </div>

            {/* Information */}
            <div>
              <h5>Information</h5>
              <div className="d-flex flex-column">
                <Link to="/privacy-policy" className="text-white-50 text-decoration-none mb-1">Privacy Policy</Link>
                <Link to="/Cancellation-Refunds" className="text-white-50 text-decoration-none mb-1">Cancellation & Refunds</Link>
                <Link to="/shipping-policy" className="text-white-50 text-decoration-none mb-1">Shipping Policy</Link>
                <Link to="/terms-conditions" className="text-white-50 text-decoration-none mb-1">Terms & Conditions</Link>
              </div>
            </div>

            {/* Account */}
            <div>
              <h5>Account</h5>
              <div className="d-flex flex-column">
                <Link to="/about" className="text-white-50 text-decoration-none mb-1">About Us</Link>
                <Link to="/contact" className="text-white-50 text-decoration-none mb-1">Contact</Link>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h5>Quick Links</h5>
              <div className="d-flex flex-column">
                <Link to="/product" className="text-white-50 text-decoration-none mb-1">Products</Link>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* Bottom Footer */}
      <footer className="py-3 bg-dark text-white-50">
        <div className="container-xxl text-center">
          <small>&copy; {new Date().getFullYear()} by vivekasoftek</small>
        </div>
      </footer>
    </>
  );
};

export default Footer;
